import type { FaireProductEntity } from "../../entity_types/product";

export const p_pws5rb77fj: FaireProductEntity = {
  token: "p_pws5rb77fj",
  type: "product",
  name: "DogDogs",
  brandToken: "b_daarv8jc3a",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/b94c1cc92e52cdc41124b3099d8d364226bed0d243197f8b1671d5ed0a1119c5.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/30139eb02b81caa06a299593fe94dd1665462bedb049c50559460cb4c15ef014.webp",
    "https://cdn.faire.com/fastly/265c3068a916b30a64a28debc923abaab72e04c8cbbcb763fdf464981e39b146.webp",
    "https://cdn.faire.com/fastly/02f66e913fa4d4b9b3061a8f15d45f4ad605a18cfc72630e8f0ae11e26f752f1.webp",
    "https://cdn.faire.com/fastly/b943fd190702661fe812135f9ebd1678d7af6039a41ce90f080770dbf9d3ed9d.webp",
    "https://cdn.faire.com/fastly/2028ec664d595f115d558a35168fdf98f756bf9234feafbf542eae6265ff1950.webp",
    "https://cdn.faire.com/fastly/a3619d84860caa704223b3362650ea5a17fd150c9a34aec6905906d4becd90f6.webp",
    "https://cdn.faire.com/fastly/7c3904f586c3a424d034d08910dd9f4cb55081d5ef43f0700a5a850cc152825d.webp",
    "https://cdn.faire.com/fastly/1781464b2d6a3548290afb19f8de7b64cb69f57382881cd3aae613dcb629d833.webp",
    "https://cdn.faire.com/fastly/cbbb7560e165b1f24f87dbee3bf3fc3ac1a69975dc3c2f60b3a20626ca89122c.webp",
    "https://cdn.faire.com/fastly/cb77b66bfc70ef32b0ff96454a8406f540575702d239846f8d7a4b6c567c298e.webp",
    "https://cdn.faire.com/fastly/6a13065c8fa1e50168e2760ddc36548e1991c138cf2496852a21d514d6b5c513.webp",
  ],
  priceDollars: 14.97,
  description:
    "A reissue of the classic and much-loved collection of 500 witty images of dogs by legendary Magnum photographer Elliott Erwitt\n\nA dog-lover’s dream, DogDogs presents the largest selection ever published of Elliott Erwitt’s images of our beloved canine companions.\n\nThis delightful volume features 500 photographs – of Poodles at dog shows, of Golden Retrievers fetching sticks in the park, of Highland Terriers jumping in the air for joy, and hundreds of other images of dogs walking, being carried, or otherwise enjoying life – all printed full-bleed in arresting duotone.\n\nAlso included in this gem of a book is a captivating essay by British writer P.G. Wodehouse, an admirer of Erwitt’s work and a keen dog-owner himself.",
  tags: [],
  msrpDollars: 29.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:32.817Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
